/**
 * ============================================================
 * SynlabFooter.js — Global Footer Component
 * ============================================================
 *
 * Displays:
 *   -> Institutional logos
 *   -> Funding logos
 *   -> Divider line
 *   -> Copyright notice
 *   -> Lab address
 *
 * Used on every PUBLIC page:
 *   -> Home, People, Projects, Publications
 *   -> Person, Project
 *
 * Pure presentational component — no props or state.
 **/

import React from "react";
import "./css/SynlabFooter.css";


// ------------------------------------------------------------
// Component
// ------------------------------------------------------------
function SynlabFooter() {
  return (
    <footer className="footer">
      <div className="footer-content">

        {/* ----- INSTITUTION LOGOS ----- */}
        <div className="footer-logo-row">
          <img src="/logos/tcs-logo.png" alt="TCS Logo" />
          <img src="/logos/synlab-logo.png" alt="SynLab Logo" />
          <img src="/logos/tmu-logo.png" alt="TMU Logo" />
        </div>

        {/* ----- FUNDING LOGOS ----- */}
        <div className="footer-logo-row funding">
          <img src="/logos/mri-logo.png" alt="MRI Logo" />
          <img src="/logos/mitacs-logo.png" alt="Mitacs Logo" />
          <img src="/logos/sshrc-logo.png" alt="SSHRC Logo" />
          <img src="/logos/nsf-logo.png" alt="NSF Logo" />
          <img src="/logos/nserc-logo.png" alt="NSERC Logo" />
          <img src="/logos/crc-logo.png" alt="CRC Logo" />          
          <img src="/logos/cfi-logo.png" alt="CFI Logo" />
        </div>

        {/* ----- DIVIDER ----- */}
        <div className="footer-divider"></div>

        {/* ----- COPYRIGHT ----- */}
        <div className="footer-copyright">
          <p>© {new Date().getFullYear()} Synaesthetic Media Lab</p>
        </div>

        {/* ----- LAB ADDRESS ----- */}
        <div className="footer-address">
          <p>
            Toronto Metropolitan Univeristy<br />
            Bell Trinity Square, Suite N103, 483 Bay St.<br />
            Toronto, ON, Canada, M5G 2E1
          </p>
        </div>

      </div>
    </footer>
  );
}

export default SynlabFooter;
